import React, { Component, useState, useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import ResizeDetector from 'react-resize-detector'

import { useWindowSize } from '../utilities/useWindowSize'

import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import CssBaseline from '@material-ui/core/CssBaseline'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import CircularProgress from '@material-ui/core/CircularProgress'

const styles = theme => ({
  root: {
    backgroundColor: '#f8f8f8'
//    width: '100%',
//    display: 'flex',
//    justifyContent: 'center'
//    backgroundColor: '#f5f5f5'
  },
  backgroundOverlay: {
    zIndex: -1,
    position: 'fixed',
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },  
  topBar: {
    position: 'fixed',
    top: 0,
    zIndex: 1100, // App Bar
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  menuButton: {
//    marginLeft: 12,
//    marginRight: 12,
  },
  menuButtonHidden: {
    display: 'none',
  },
  linearProgress: {
    position: 'fixed',
    height: 2,
    overflow: 'hidden',
    width: '100%',
    zIndex: 1250 // Above Drawer (1200)
  },
  title: {
    flexGrow: 1,
    fontWeight: 800,
    paddingLeft: theme.spacing.unit * 2,
  },
  appBarSpacer: theme.mixins.toolbar,
  bottomBarSpacer: {
    height: theme.mixins.toolbar.height,
  },
  content: {
    flexGrow: 1,
    overflow: 'auto',
    width: '100%',
  },
  chartContainer: {
    marginLeft: -22,
  },
  tableContainer: {
    height: 320,
  },
  h5: {
    marginBottom: theme.spacing.unit * 2,
  },
  bottomNavBarMenu: {
    width: '100%',
    position: 'fixed',
    bottom: 60 + 8,
    textAlign: 'center',
    'z-index': 1050 // Below appbar (1100)
  },
  bottomNavBar: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    },
  },
  sideContent: {
    width: 400,
//    paddingTop: theme.spacing(4)
  },
  sideContentCloseButton: {
    position: 'fixed',
    top: theme.spacing.unit,
    right: theme.spacing.unit,
    'z-index': 1350
  },  
  popupContentCloseButton: {
    position: 'fixed',
    top: theme.spacing.unit,
    right: theme.spacing.unit,
    'z-index': 1350
  },
  poweredBy: {
    color: '#aaa',
    fontSize: 12,
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3),
    },
  },
})

export const NavigationContext = React.createContext({})

// Help scroll to top on page change
class ScrollToTopView extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      if (this.props.location.search) {
        let sp = new URLSearchParams(this.props.location.search)
        if (sp.get('popup') == 1)
          return
      }

      if (prevProps.location.search) {
        let sp = new URLSearchParams(prevProps.location.search)
        if (sp.get('popup') == 1)
          return
      }
  
      window.scrollTo(0, 0)
    }
  }
  
  render() {
    return this.props.children
  }
}

const ScrollToTop = withRouter(ScrollToTopView)

const NavigationController = ({ theme, classes, backgroundImageUrl, topBar, topBarOverlayColor, bottomBar, children, fitToWindow=false, openLink }) => {
  
  const [windowWidth, windowHeight] = useWindowSize()  
  
  const [contentInset, setContentInset] = useState({ top: 0, left: 0, right: 0, bottom: 0})
  const [topBarHidden, setTopBarHidden] = useState(false)
  const [bottomBarHidden, setBottomBarHidden] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [transparentBackground, setTransparentBackground] = useState(false)
  const [sideBarContent, setSideBarContent] = useState(null)
  const [popupContent, setPopupContent] = useState(null)
  const [openWait, setOpenWait] = useState(false)
  const [openMessage, setOpenMessage] = useState(false)
  const [messageDialog, setMessageDialog] = useState(null)
    
  const navigationContext = {
    contentInset,
    fitToWindow,
    openLink,
    hasTopBar: topBar ? true : false,
    hasBottomBar: bottomBar ? true : false,
    isTopBarHidden: topBarHidden,
    isBottomBarHidden: bottomBarHidden,
    showLoadingDialog: setOpenWait,
    showMessageDialog: setOpenMessage,
    setMessageDialog: setMessageDialog,
    setLoading: setLoading,
    setTransparentBackground: setTransparentBackground,
    showSideBar: (content, onHide=null) => {
      if (content)
        setSideBarContent({content, onHide})
      else
        setSideBarContent(null)
    },
    showPopup: (content, onHide=null) => {
      if (content)
        setPopupContent({content, onHide})
      else
        setPopupContent(null)
    },
  }
  
  let visibleContentInset = {
    ...contentInset,
    top: topBarHidden ? 0 : contentInset.top,
    bottom: bottomBarHidden ? 0: contentInset.bottom
  }  
  
  let rootStyle = {}
  let contentStyle = {}
  
  if (fitToWindow) {
    rootStyle = {
      width: `${windowWidth}px`,
      height: `${windowHeight}px`,
      position: 'fixed',
      top: 0,
      left: 0,
    }
    
    contentStyle={
      marginTop: visibleContentInset.top,
      //height: `calc(100% - ${contentInset.top}px)`,
      minHeight: windowHeight - contentInset.top,
      position: 'relative',
    }
  }
  else {
    rootStyle = {
    }
    
    contentStyle={
      marginTop: visibleContentInset.top,
      minHeight: windowHeight - contentInset.top,
      //minHeight: `calc(100vh - ${contentInset.top}px)`,
      //height: `calc(100% - ${contentInset.top}px)`,
      position: 'relative',      
    }    
  }
    
  let sideBarVisible = sideBarContent ? true : false
  let popupVisible = popupContent ? true : false
  
  const closePopup = () => {
    if (popupContent && popupContent.onHide)
      popupContent.onHide()
    else
      setPopupContent(null)
  }                                                                                                                                                                                                                                                                                                                     
  
  const closeSideBar = () => {
    if (sideBarContent && sideBarContent.onHide)
      sideBarContent.onHide()
    else
      setSideBarContent(null)
  }

  return (      
  <div className={classes.root} style={rootStyle}>
    <NavigationContext.Provider value={ navigationContext }>
    <ScrollToTop>
      <CssBaseline />

      { backgroundImageUrl &&
        <div className={classes.backgroundOverlay}
          style={{ backgroundImage: `url("${backgroundImageUrl}")` }}
          >
        </div>
      }

      { topBar &&
        <>
          { backgroundImageUrl && topBarOverlayColor &&
            <>
              <div className={classes.topBar}
                style={{
                  height: contentInset.top,
                  backgroundColor: topBarOverlayColor,
                  overflow: "hidden",
                  // Without this, we can't tap on content area. Probably because of background div
                  pointerEvents: "none"
                }}
                >
                <div className={classes.topBar}
                  style={{
                    height: "100%",
                    height: contentInset.top,
                    // backgroundColor: topBarOverlayColor,
                    //filter: "blur(20px)",
                    opacity: "0.2",
                    backgroundImage: `url("${backgroundImageUrl}")`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    filter: "blur(10px)",
                    transform: "scale(1.2)"
                  }}
                  />
              </div>
            </>
          }

          <div className={classes.topBar}>
            <ResizeDetector
              handleHeight
              render={({ height }) => {
                if (height != contentInset.top)
                  setContentInset({...contentInset, top:height})
                return topBar
              }}
            />
          </div>
        </>
      }

      <main className={classes.content}
        style={contentStyle}
        >      
        { children }
        <div style={{ height: visibleContentInset.bottom }} />
      </main>
            
      <div className={classes.linearProgress} 
        style={ isLoading ? {} : { display: 'none' } } >
        <LinearProgress />
      </div>

      {/* Dialog Loading */}
      <Dialog
                open={openWait}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={"sm"}
                disableBackdropClick
                disableEscapeKeyDown
            >
                <DialogContent>
                <DialogContentText>
                    <Box display='flex' flexDirection='row' alignItems='center'>
                        <CircularProgress style={{marginRight: '16px'}}/>
                        <Typography>
                            Please Wait...
                        </Typography>
                    </Box>
                </DialogContentText>
                </DialogContent>
            </Dialog>

            {/* Dialog with Message */}
            {messageDialog && 
            <Dialog
              open={openMessage}
              onClose={() => {setMessageDialog(null);setOpenMessage(false)}}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth={'xs'}
              fullWidth
            >
              <DialogTitle id="alert-dialog-title">{messageDialog && messageDialog.title || 'Cool!'}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {messageDialog && messageDialog.description || 'Thank You.'}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => {setMessageDialog(null);setOpenMessage(false)}} color="primary" id='closeAccept' autoFocus>
                  OK
                </Button>
              </DialogActions>
            </Dialog>
            }
    </ScrollToTop>
    </NavigationContext.Provider>
  </div>
  )
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    NavigationController
  )
)